<section>
  <h1 class="header list-header">{{ 'INVOICE.HEADER' | translate }}</h1>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [itemsSource]="itemsSource"
    [menuDefinition]="menuDefinition"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
    [preferencesKey]="'invoice.rental-object-invoices'"
  >
  </app-multiselect-list-view>
</section>
